import { render, staticRenderFns } from "./roleTree.vue?vue&type=template&id=7d5db522&scoped=true"
import script from "./roleTree.vue?vue&type=script&lang=js"
export * from "./roleTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5db522",
  null
  
)

export default component.exports